/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsObjectsAllowCreateInvoiceOption } from './WebApiIntegrationsObjectsAllowCreateInvoiceOption';
import {
    WebApiIntegrationsObjectsAllowCreateInvoiceOptionFromJSON,
    WebApiIntegrationsObjectsAllowCreateInvoiceOptionFromJSONTyped,
    WebApiIntegrationsObjectsAllowCreateInvoiceOptionToJSON,
} from './WebApiIntegrationsObjectsAllowCreateInvoiceOption';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoIntegrationSyncConfigDto
 */
export interface WebApiIntegrationsDtoIntegrationSyncConfigDto {
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncCreate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncUpdateData?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncUpdateStatus?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncEmail?: boolean;
    /**
     * Fortnox-specific: sync email to InvoiceEmail field as well.
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncEmailInvoice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncPhone?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncAddress?: boolean;
    /**
     * Fortnox-specific: send Company as address row 1 (street address moves to row 2).
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncCompanyAsAddressRow1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncZipCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncCity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncPersonalNumber?: boolean;
    /**
     * Which Extra field to map to integration Notes/Comments.
     * null = disabled, 1 = Extra1, 2 = Extra2, 3 = Extra3.
     * @type {number}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    syncExtraToNotes?: number | null;
    /**
     * 
     * @type {WebApiIntegrationsObjectsAllowCreateInvoiceOption}
     * @memberof WebApiIntegrationsDtoIntegrationSyncConfigDto
     */
    allowCreateInvoice?: WebApiIntegrationsObjectsAllowCreateInvoiceOption;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoIntegrationSyncConfigDto interface.
 */
export function instanceOfWebApiIntegrationsDtoIntegrationSyncConfigDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoIntegrationSyncConfigDtoFromJSON(json: any): WebApiIntegrationsDtoIntegrationSyncConfigDto {
    return WebApiIntegrationsDtoIntegrationSyncConfigDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoIntegrationSyncConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoIntegrationSyncConfigDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'integrationType': !exists(json, 'integrationType') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['integrationType']),
        'syncCreate': !exists(json, 'syncCreate') ? undefined : json['syncCreate'],
        'syncUpdateData': !exists(json, 'syncUpdateData') ? undefined : json['syncUpdateData'],
        'syncUpdateStatus': !exists(json, 'syncUpdateStatus') ? undefined : json['syncUpdateStatus'],
        'syncName': !exists(json, 'syncName') ? undefined : json['syncName'],
        'syncEmail': !exists(json, 'syncEmail') ? undefined : json['syncEmail'],
        'syncEmailInvoice': !exists(json, 'syncEmailInvoice') ? undefined : json['syncEmailInvoice'],
        'syncPhone': !exists(json, 'syncPhone') ? undefined : json['syncPhone'],
        'syncAddress': !exists(json, 'syncAddress') ? undefined : json['syncAddress'],
        'syncCompanyAsAddressRow1': !exists(json, 'syncCompanyAsAddressRow1') ? undefined : json['syncCompanyAsAddressRow1'],
        'syncZipCode': !exists(json, 'syncZipCode') ? undefined : json['syncZipCode'],
        'syncCity': !exists(json, 'syncCity') ? undefined : json['syncCity'],
        'syncPersonalNumber': !exists(json, 'syncPersonalNumber') ? undefined : json['syncPersonalNumber'],
        'syncExtraToNotes': !exists(json, 'syncExtraToNotes') ? undefined : json['syncExtraToNotes'],
        'allowCreateInvoice': !exists(json, 'allowCreateInvoice') ? undefined : WebApiIntegrationsObjectsAllowCreateInvoiceOptionFromJSON(json['allowCreateInvoice']),
    };
}

export function WebApiIntegrationsDtoIntegrationSyncConfigDtoToJSON(value?: WebApiIntegrationsDtoIntegrationSyncConfigDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'integrationType': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.integrationType),
        'syncCreate': value.syncCreate,
        'syncUpdateData': value.syncUpdateData,
        'syncUpdateStatus': value.syncUpdateStatus,
        'syncName': value.syncName,
        'syncEmail': value.syncEmail,
        'syncEmailInvoice': value.syncEmailInvoice,
        'syncPhone': value.syncPhone,
        'syncAddress': value.syncAddress,
        'syncCompanyAsAddressRow1': value.syncCompanyAsAddressRow1,
        'syncZipCode': value.syncZipCode,
        'syncCity': value.syncCity,
        'syncPersonalNumber': value.syncPersonalNumber,
        'syncExtraToNotes': value.syncExtraToNotes,
        'allowCreateInvoice': WebApiIntegrationsObjectsAllowCreateInvoiceOptionToJSON(value.allowCreateInvoice),
    };
}

